import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';

const StyledLink = link => {
  const style = {
    flexDirection: 'row',
    justifyContent: 'center'
  };
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "medium",
    color: Colors.advanceBlue300,
    onPress: link.onPress
  }, link.label));
};

export default function Password(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLink, {
    label: "Forgot Password?",
    onPress: props.links.forgotPassword
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "regular",
    color: Colors.gray500,
    align: "center"
  }, "Don't have an account? ", /*#__PURE__*/React.createElement(StyledLink, {
    label: "Sign up",
    onPress: props.links.signUp
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }));
}
Password.defaultProps = {
  links: {
    forgotPassword: () => {},
    signUp: () => {}
  }
};
Password.propTypes = {
  links: PropTypes.shape({
    forgotPassword: PropTypes.func,
    signUp: PropTypes.func
  })
};
//# sourceMappingURL=password.js.map